import { IStore } from 'old-store/types';
import { CustomizableBannerType } from './types';

export const selectBanners = (state: IStore) => state.banners;

export const selectCustomizableBanners = (state: IStore) =>
  selectBanners(state)?.customizableBanners || [];

export const selectOrderDeadlineBanner = (state: IStore) =>
  selectCustomizableBanners(state).find(
    ({ type, enabled, showUntil }) =>
      type === CustomizableBannerType.ORDER_DEADLINE && enabled && new Date(showUntil) >= new Date()
  );
